import { Button, Divider, Stack } from '@mui/material'

import { Fragment } from 'react'

import { useLandingZoneMigration } from '@features/hooks/LandingZones/migration'

export const Footer = () => {
    const { handleNext } = useLandingZoneMigration()

    return (
        <Fragment>
            <Divider />
            <Stack direction={'row'} alignItems={'center'} justifyContent={'end'} sx={{p: 2}}>
                <Button onClick={handleNext}>Validate migration</Button>
            </Stack>
        </Fragment>
    )
}

export default Footer